import api from "./api";

export class ChapterService {
    async getChaptersDetails(transporterId: string, driverId: string) {
        // Updated to get only selected chapters for the driver
        return api.get(`/chapters/driver/${driverId}/transporter/${transporterId}`);
    }

    async calculate(userAnswers: {id: string, answers: string[]}[]) {
        return api.post(`/chapters/calculate`, {userAnswers});
    }

    async markChapterAsCompleted(driverId: string, chapterId: string) {
        return api.post(`/drivers/${driverId}/completed-chapters`, { chapterId });
    }
}
